import React from 'react'

import { OptionToggle as WCOptionToggle } from '@acorns/web-components'
import styled from 'styled-components'

const StyledToggle = styled(WCOptionToggle)`
  margin-left: auto;
  margin-right: 0;
  
  .react-toggle-track {
    width: 52px;
    height: 32px;
  }
  
  .react-toggle-thumb {
    width: 28px;
    height: 28px;
  }
  
  &.react-toggle--checked .react-toggle-thumb {
    left: auto;
    right: 2px;
  }
`

const OptionToggle = (props) => <StyledToggle {...props} />

export default OptionToggle
